'use client';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ReactNode } from 'react';
import { getEnvVar } from '@vimond/utils/env';

const ElementsProvider = ({
  children,
  stripePk,
}: {
  children: ReactNode;
  stripePk: string | undefined;
}) => {
  if (!stripePk) {
    return <>{children}</>;
  }
  const stripePromise = loadStripe(stripePk ?? '', {
    stripeAccount: getEnvVar('NEXT_PUBLIC_STRIPE_ACCOUNT_ID'),
  });
  return (
    <Elements
      stripe={stripePromise}
      options={{
        mode: 'setup',
        currency: 'eur',
      }}
    >
      {children}
    </Elements>
  );
};

export default ElementsProvider;
